import type { SendWizardStep } from '../types';

export const RECIPIENTS_PAGE_SIZE = 10;

export const SEND_STEPS: { step: SendWizardStep; label: string }[] = [
  { step: 1, label: 'Destinatários' },
  { step: 2, label: 'Mensagem' },
  { step: 3, label: 'Revisão' },
];

export const STATUS_TOOLTIPS = {
  ativo: 'Cadastro concluído, com senha criada.',
  pendente: 'Cadastro enviado, aguardando criação de senha pelo usuário.',
} as const;

export const EMPTY_SELECTION_TOAST = {
  title: 'Atenção',
  description: 'Adicione ao menos um destinatário para seguir com o envio',
} as const;

export const EMPTY_MESSAGE_TOAST = {
  title: 'Atenção',
  description: 'Preencha o assunto e o corpo do e-mail para continuar',
} as const;

export const DEFAULT_EMAIL_SUBJECT = 'Chegou o seu Culture Monitor!';

export const getDefaultEmailBody = (edition?: string) => {
  const editionLabel = edition?.trim() ? `#${edition.trim()}` : '#XX';
  return `<p>Oi! O Culture Monitor de hoje já está disponível.</p><p>A edição ${editionLabel} reúne os principais movimentos da cultura, conversas, tendências e oportunidades para a sua marca acompanhar o que está acontecendo agora e o que pode ganhar força nos próximos dias.</p><p>Boa leitura e até mais!</p>`;
};
